import React,{useEffect,useState} from 'react';
import './styles/App.css';
import myeditprofile from './img/Ellipse 1.png';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import M_Footer from './M_Footer';
import axios from 'axios';
import { instance } from './common';
import Logout from './Logout';



function DeleteModal({modal,toggle,u_login_id,chk,setChk}){
    
    const [pw, setPw] = useState('');
    

    const chkPw =  () => {
        let obj = {
            u_login_id:u_login_id,
            u_pwd:pw,
        }
        instance.post('/users/pw-check',obj).then(function(res){
            alert(res.data.msg);
            setChk(res.data.chk);
        });
    }


    const deleteBtn = () => {
        let chkConfrim = window.confirm('정말 탈퇴하시겠습니까?');
        if(chkConfrim){
            const fetchData = async () => {
                instance.post('/users/u_delete',
                {id:u_login_id})
                .then(function(res){
                    alert('정상적으로 삭제되었습니다.');
                });
            
            };
        
            fetchData();
            
            window.sessionStorage.clear();
            window.location.replace("/");
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>비밀번호 확인</ModalHeader>
                <ModalBody>
                    <div className="col-12">
                        <label>비밀번호 확인</label>
                        <input 
                            type="password" 
                            name="u_pwd2"  
                            className="form-control"  
                            placeholder="비밀번호를 입력해주세요" 
                            onChange={(e) => setPw(e.target.value)}
                            value={pw}
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    {
                        chk
                        ?<Button color="primary" onClick={deleteBtn}>탈퇴하기</Button>
                        :<Button color="primary" onClick={chkPw}>비밀번호 확인</Button>
                    }       
                <Button color="secondary" onClick={toggle}>취소</Button>
                </ModalFooter>
        </Modal>
    )
}

function Mypageedit({history}) {

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    //탈퇴 모달용
    const [d_modal, setd_Modal] = useState(false);

    const d_toggle = () => setd_Modal(!d_modal);
    const [chk, setChk] = useState(false);

    let session = JSON.parse(window.sessionStorage.result);
    let {u_login_id} = session;

  
  const [data, setData] = useState({});

  const [modifyObj, setModifyObj] = useState({
    u_nick:'',
    u_email:'',
    u_phone:'',
    u_uuid:'',
    u_company_num:'',
    u_company_name:'',
    u_bank:'',
    u_holder:"",
    u_account:"",
  });
  

  let obj = {
    u_login_id:u_login_id,  
  }
  useEffect(() => {
    
    const fetchData = async () => {
        instance.post('/users/id',obj).then(function(res){
            setData(res.data[0]);
            console.log('data', data);
            setModifyObj({
                u_nick:res.data[0].u_nick,
                u_email:res.data[0].u_email,
                u_phone:res.data[0].u_phone,
                u_uuid:res.data[0].u_uuid,
                u_type:res.data[0].u_type,
                u_company_num:res.data[0].u_company_num,
                u_company_name:res.data[0].u_company_name,
                u_bank:res.data[0].u_bank,
                u_holder:res.data[0].u_holder,
                u_account:res.data[0].u_account,
            })
        });
    
    };

    fetchData();

  }, []);

  
  console.log('data', obj)
  const {u_nick,u_email,u_phone,u_uuid,u_type,u_company_num,u_company_name,u_bank,u_holder,u_account} = data;

  const u_login_id2 = data.u_login_id;

  const [modifyPwObj, setModifyPwObj] = useState({
    u_pwd:'',
  });
  

  const inputChange = (e) => {
    const {name,value} = e.target;
    setData({
        ...data,
        [name]:value
    })
    setModifyObj({
        ...modifyObj,
        [name]:value
    })
    setModifyPwObj({
        ...modifyPwObj,
        [name]:value
    })

}

    const modify = () => {

        console.log('수정 직 전 modifyObj : ',modifyObj)
 
        const fetchData = async () => {
            instance.post('/users/update',
            {obj:modifyObj,whereField:'u_login_id',whereValue:u_login_id2})
            .then(function(res){
                console.log('res : ', res)
                let myInfo = JSON.parse(window.sessionStorage.result);
                myInfo.u_uuid = u_uuid;
                window.sessionStorage.setItem('result', JSON.stringify(myInfo));
                alert('정상적으로 수정되었습니다.');
            });
        
        };
    
        fetchData();
    }
    const changePwd = () => {

        console.log('data23 : ', modifyPwObj)
 
        const fetchData = async () => {
            instance.post('/users/update/pwd',
            {u_pwd:modifyPwObj,u_login_id:u_login_id2})
            .then(function(res){
                alert('정상적으로 수정되었습니다.');
            });
        
        };
    
        fetchData();
    }
    const deleteUser = () => {
        setChk(false);
        d_toggle(true);
    }


    const goLogout = () => {
        const {u_social} = JSON.parse(window.sessionStorage.result);
        history.push('/Logout?kind='+u_social);
    }

    const uploadImage = (e) => {
        const {id,files} = e.target;
        let file = files[0];
        let dir = u_login_id2;

        let formData = new FormData();
        formData.append('dir', dir);
        formData.append('img', file);
        fileUpload(formData,id);
    }

    const fileUpload = (formdata,id) => {
        const fetchData = async () => {
            instance.post('/file/image',formdata,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                  }
            })
            .then(function(res){
                console.log('res : ', res);
                let path = res.data.path;
                path = path.slice(7,path.length)
                let url = 'https://abys-service.co.kr:3001//'+path;
                setModifyObj({
                    ...modifyObj,
                    u_uuid:url
                })
                setData({
                    ...data,
                    u_uuid:url
                })
            });
        
        };
    
        fetchData();
    }


  return (
    <>
    <div className="container mb-5">
        <div className="row">
            <div className="col-12 d-inline-block text-center mt-5">
                {
                    u_uuid
                    ?<div className="mypageEdit_img d-inline-block" style={{background:'url(\''+u_uuid+'\')'}}></div>
                    :<div className="mypageEdit_img d-inline-block" ></div>
                }
                
            </div>
            <div className="col-12 text-center mt-3">
                <label htmlFor="file-upload" className="btn btn-link btn-sm p rounded-pill text-center mpEdit-btn">EDIT</label>
                <input id="file-upload" type="file" className="d-none" accept="image/png, image/jpeg, image/jpg" onChange={uploadImage}/>
            </div>
            <div className="mt-5 myEdint-content">
                <div className="input">ID</div>
                    <input name="u_login_id"  onChange={inputChange} className="mt-2 userIdlogin" value={u_login_id2} type="text" />
                <div className="input mt-5">성함</div> 
                    <input name="u_nick" placeholder="아비스" className="mt-2 password" onChange={inputChange} type="text" value={u_nick} />
                <div className="input mt-5">이메일</div> 
                    <input name="u_email" className="mt-2 password" type="text" onChange={inputChange} value={u_email} /> 
                <div className="input mt-5">휴대폰 번호</div> 
                    <input name="u_phone" className="mt-2 password" type="text" onChange={inputChange} value={u_phone} /> 
                {
                    u_type == '시공지점'
                    ?<div className="" >
                        <div className="input mt-5">사업자등록번호</div> 
                    <input name="u_company_num" className="mt-2 password" type="text" onChange={inputChange} value={u_company_num} />
                    <div className="input mt-5">사업자명</div> 
                    <input name="u_company_name" className="mt-2 password" type="text" onChange={inputChange} value={u_company_name} /> 
                    </div>
                    :<div className="" ></div>
                }
            </div>
            <div className="myEdit_down">
                <button type="button" className="btn btn-primary myEdit_downbtn" onClick={modify}>개인정보 수정</button> 
                <button type="button" className="btn btn-primary myEdit_downbtn mt-4" onClick={toggle}>비밀번호 변경</button>
                {/* <button type="button" onClick={goLogout} className="btn btn-primary myEdit_downbtn mt-4">로그아웃</button>  */}
                <button type="button" onClick={deleteUser} className="btn btn-primary myEdit_downbtn mt-4">탈퇴</button> 
            </div>     
        </div>
    </div>

    <div>
         <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>비밀번호 변경</ModalHeader>
                <ModalBody>
                <div className="col-12 mb-3">
                            <label>비밀번호</label>
                            <input type="password" name="u_pwd" onChange={inputChange} className="form-control" placeholder="변경할 비밀번호를 입력해주세요" />
                        </div>
                        <div className="col-12">
                            <label>비밀번호 확인</label>
                            <input type="password" name="u_pwd2"  className="form-control"  placeholder="같은 비밀번호를 입력해주세요" />
                        </div>
                </ModalBody>
                <ModalFooter>
                <Button color="primary" onClick={changePwd}>비밀번호 수정</Button>{' '}
                <Button color="secondary" onClick={toggle}>취소</Button>
                </ModalFooter>
        </Modal>
    </div>
    <DeleteModal 
    modal={d_modal} 
    toggle={d_toggle} 
    u_login_id={u_login_id}
    chk={chk}
    setChk={setChk}
    />                
    </>
  );
}

export default Mypageedit;